import { render, staticRenderFns } from "./hotSourceCode.vue?vue&type=template&id=5f2c1a36&scoped=true"
import script from "./hotSourceCode.vue?vue&type=script&lang=js"
export * from "./hotSourceCode.vue?vue&type=script&lang=js"
import style0 from "./hotSourceCode.vue?vue&type=style&index=0&id=5f2c1a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c1a36",
  null
  
)

export default component.exports